import React from 'react';

const Banner = ({ bannerItem, IMG_URL, onPlayClick }) => {
  // If no banner data is available (e.g., during initial load), render nothing.
  if (!bannerItem) {
    return null;
  }

  return (
    // Main container with responsive aspect ratio using the padding-top trick.
    <div className="relative pt-[75vh] md:pt-[45%] lg:pt-[40%] bg-gray-900">
      
      {/* Background layer with image and a gradient for text readability */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ 
          backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.7) 30%, rgba(0,0,0,0) 100%), url(${IMG_URL}${bannerItem.backdrop_path})`,
          backgroundPosition: 'center center'
        }}
      >
        {/* Bottom fade-to-black gradient for blending with content below */}
        <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-black to-transparent"></div>
      </div>
      
      {/* Content layer for text and buttons */}
      <div className="absolute bottom-0 left-0 p-4 md:p-8 lg:p-12 w-full md:w-2/3 lg:w-1/2">
        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2 md:mb-4 drop-shadow-lg">
          {/* Display title or name, accommodating both movies and TV shows */}
          {bannerItem.title || bannerItem.name}
        </h1>
        <p className="text-sm sm:text-base md:text-lg mb-4 md:mb-6 line-clamp-2 md:line-clamp-3 drop-shadow-lg">
          {bannerItem.overview}
        </p>
        <div className="flex space-x-3 md:space-x-4">
          <button 
            onClick={onPlayClick} // This calls the function passed from the parent component
            className="px-4 py-2 md:px-6 md:py-3 bg-white text-black rounded flex items-center hover:bg-opacity-80 text-sm md:text-base font-medium transition-transform transform hover:scale-105"
          >
            <svg className="w-4 h-4 md:w-5 md:h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
            </svg>
            Play
          </button>
          <button className="px-4 py-2 md:px-6 md:py-3 bg-gray-600 bg-opacity-70 rounded flex items-center hover:bg-opacity-50 text-sm md:text-base font-medium transition-transform transform hover:scale-105">
            <svg className="w-4 h-4 md:w-5 md:h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
            </svg>
            My List
          </button>
        </div>
      </div>
    </div>
  );
};

export default Banner;